import * as yup from "yup";

import i18n from "@swa-ui/locale";

import { COUNTRY_SCHEMA_FIELD_NAME } from "../CountryFormField/CountryFormField.schema";

const NON_US_POSTAL_CODE_REGEX = /^[A-Za-z\d\s\-()]*$/;
const ZIP_CODE_MIN_LENGTH = 1;

export const ZIP_CODE_US_MAX_LENGTH = 5;
export const ZIP_CODE_NON_US_MAX_LENGTH = 17;

export const ZIPCODE_SCHEMA_FIELD_NAME = "postalCode";
export const UNITED_STATES_COUNTRY_CODE = "US";

export const getZipCodeFormFieldSchema = (
  countryFieldName = COUNTRY_SCHEMA_FIELD_NAME,
  label = i18n("ZipCodeFormField__LABEL")
) => {
  const baseSchema = yup.string().trim().label(label.toLowerCase());

  return yup.string().when(countryFieldName, {
    is: (country) => country === UNITED_STATES_COUNTRY_CODE,
    otherwise: yup.lazy((value) =>
      value
        ? baseSchema
            .min(ZIP_CODE_MIN_LENGTH)
            .max(ZIP_CODE_NON_US_MAX_LENGTH)
            .matches(NON_US_POSTAL_CODE_REGEX)
        : baseSchema
    ),
    then: () => baseSchema.required().length(ZIP_CODE_US_MAX_LENGTH).numeric(),
  });
};
